import { computed, unref } from "vue";
import { defineNuxtPlugin } from "#app/nuxt";
import { localeContextInjectionKey } from "/var/www/html/node_modules/@nuxt/ui/dist/runtime/composables/useLocale";
import en from "/var/www/html/node_modules/@nuxt/ui/dist/runtime/locale/en";
import es from "/var/www/html/node_modules/@nuxt/ui/dist/runtime/locale/es";
const locales = {
  en: en,
  es: es
}
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.provide(localeContextInjectionKey, computed(() => locales[unref(nuxtApp.$i18n?.locale)]))
})